export const TITLE_MAP = {
  custom_audiences: {
    'ages[]': 'Ages',
    'destinations[]name': 'Destinations',
    'genders[]': 'Genders',
    'incomes[]': 'Incomes',
    'languages[]name': 'Languages',
    name: 'Name',
    'regions[]name': 'Regions',
    'retailerPreference[]': 'Retailer preference',
    status: 'Status',
    'topics[]atoms:keywords': 'Topics',
    'topics[]atoms:keywords[]': 'Topics (spread)',
    'topics[]atoms:keywords[](unique)': 'Topics atoms (spread, unique)',
    'topics[]name': 'Topics names',
  },
}

export const makeLink = (collection, id) => {
  switch (collection) {
    case 'custom_audiences':
      return `/audience-creator/${id}`

    default:
      return false
  }
}

export const handleArray = (data) => (Array.isArray(data) ? data.join(', ') : data)
